import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  addAccredition,
  deleteAccredition,
  getAccredition,
  updateAccredition,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ManageAccredition = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const [formData, setFormData] = useState({ name: "" });
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState([]);
  const [fetchAllDataLoading, setGetAllDataLoading] = useState(false);
  const [editData, setEditData] = useState(null);

  const fetchData = async () => {
    try {
      setGetAllDataLoading(true);
      const res = await getAccredition();
      console.log("fetched Data", res);
      if (res?.status) {
        setAllData(res?.data);
        setGetAllDataLoading(false);
      } else {
        toast.error("Error while Fetching Accredition Data");
        setGetAllDataLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch accreditation");
      console.error("Error fetching accreditation:", error);
      setGetAllDataLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      name: "SL. NO",
      selector: (row, index) => index + 1,
      center: true,
    },
    {
      name: "Accredition",
      selector: (row) => row?.name,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                setEditData(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const handleCreate = async (e) => {
    e?.preventDefault();

    try {
      setLoading(true);
      const res = await addAccredition(formData);
      console.log("accreditation Add Message", res);
      if (res?.status) {
        toast.success(res?.message);

        setFormData({ name: "" });
        fetchData();
        setLoading(false);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Accredition.");
      console.error("Error adding Accredition:", error);
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();

    try {
      setLoading(true);
      const res = await updateAccredition(editData?._id, {
        name: editData?.name,
      });
      console.log("accreditation Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("Country added successfully!");
        fetchData();
        setEditData(null);
        setLoading(false);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update accreditation.");
      console.error("Error updating accreditation:", error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Accredition?",
      text: "Are you sure you want to delete this Accredition?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteAccredition(id);
        Swal.fire("Deleted!", "Accredition has been deleted.", "success");
        fetchData();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Accredition.", "error");
      }
    }
  };

  return (
    <>
      {!editData && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage Accredition
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreate(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Accredition Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={formData?.name}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          name: e?.target?.value,
                        }));
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter Accredition Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={loading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {loading ? "Loading..." : "Add Accredition"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editData && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={allData}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchAllDataLoading}
              />
            </section>
          </div>
        </div>
      )}
      {editData && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update Accredition
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdate(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Accredition Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={editData?.name}
                      onChange={(e) => {
                        setEditData((prev) => ({
                          ...prev,
                          name: e.target.value,
                        }));
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter Country Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center gap-4"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={loading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                  <button
                    onClick={() => {
                      //   handleCancel();
                      setEditData(null);
                    }}
                    // disabled={updateCountryLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageAccredition;
